"use client";

import React from "react";
import Link from "next/link";
import BrandName from "../BrandName";
import "../../css/SubHero.css";

const SubHero: React.FC = () => {
  return (
    <section className="subhero-section">
      <div className="subhero-container">
        <h2>EMPOWERING FACILITIES TO DELIVER EXCEPTIONAL CARE</h2>
        <p>
          In the demanding world of long-term care, where compliance burdens,
          staffing challenges, and resident needs collide, <BrandName variant="light" /> stands
          as your all-in-one AI ally. We empower facilities and providers to
          simplify operations, ensure regulatory excellence, and prioritize
          compassionate, data-driven care.
        </p>
        <p>
          Join the revolution—reduce risks, save time, and elevate outcomes for
          residents and staff alike.
        </p>
        <Link href="/contact" className="demo-button">REQUEST A DEMO</Link>
      </div>
    </section>
  );
};

export default SubHero;
